/* tslint:disable */
/* eslint-disable */
/**
 * Salv AML Platform internal API
 * Salv AML Platform internal API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import * as runtime from '../runtime';
import {
    InternalApiCaseStatus,
    InternalApiCaseStatusFromJSON,
    InternalApiCaseStatusToJSON,
} from '../models';

/**
 * 
 */
export class CaseStatusInternalApi extends runtime.BaseAPI {

    /**
     * Fetches all case statuses for the organisation
     */
    async findAllCaseStatusesRaw(initOverrides?: RequestInit): Promise<runtime.ApiResponse<Array<InternalApiCaseStatus>>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", ["aml"]);
        }

        const response = await this.request({
            path: `/v1/cases/statuses`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(InternalApiCaseStatusFromJSON));
    }

    /**
     * Fetches all case statuses for the organisation
     */
    async findAllCaseStatuses(initOverrides?: RequestInit): Promise<Array<InternalApiCaseStatus>> {
        const response = await this.findAllCaseStatusesRaw(initOverrides);
        return await response.value();
    }

}
